module.exports = __webpack_public_path__ + "img/NLongShip64_ua.cba37b7e.webp";